import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import Loader from '../common/Loader';
import { USER_ROLES } from '../../constants/roles';
import { useAuth } from '../../hooks/useAuth';

// Mirrors ProtectedRoute exactly, plus a role check - reuses the same
// AuthContext/session state (no independent admin auth, no separate
// /auth/me call). This is a UX guard only: every /api/admin/* call is
// still enforced server-side by get_current_admin regardless of what
// this component decides to render.
function AdminRoute() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <Loader label="Loading KrishvaQ..." />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== USER_ROLES.ADMIN) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return <Outlet />;
}

export default AdminRoute;
